import {
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from '@material-ui/core';
import { Formik } from 'formik';
import React, { useEffect } from 'react';
import FormBtns from '../../../../common/components/buttons/formBtns';
import PhoneNumberTextField from '../../../../common/components/fields/PhoneNumberTextField';
import { UserDto, userInit, userValidationSchema } from '../../users.dtos';

interface IProps {
  user: UserDto;
  onClose: () => void;
  onSave: (user: UserDto) => void;
}

const UserForm: React.FC<IProps> = ({ user, onClose, onSave }) => {
  const [dto, setDto] = React.useState<UserDto>(userInit);

  useEffect(() => {
    setDto(user);
  }, [user]);

  return (
    <Formik
      initialValues={dto}
      validationSchema={userValidationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setTimeout(() => {
          setSubmitting(false);
          resetForm();
        }, 700);

        onSave(values);

        onClose();
      }}
      enableReinitialize={true}
    >
      {(props) => {
        const {
          values,
          errors,
          isSubmitting,
          touched,
          setFieldValue,
          handleBlur,
          handleChange,
          handleSubmit,
        } = props;
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Card>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      size='small'
                      margin='none'
                      value={values.firstName || ''}
                      label='First Name'
                      name='firstName'
                      onChange={handleChange}
                      onBlur={(e) => {
                        handleBlur(e);
                      }}
                      error={Boolean(errors.firstName && touched.firstName)}
                      helperText={
                        Boolean(errors.firstName) &&
                        touched.firstName &&
                        errors.firstName
                      }
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <TextField
                      size='small'
                      margin='none'
                      value={values.lastName || ''}
                      label='Last Name'
                      name='lastName'
                      onChange={handleChange}
                      onBlur={(e) => {
                        handleBlur(e);
                      }}
                      error={Boolean(errors.lastName && touched.lastName)}
                      helperText={
                        Boolean(errors.lastName) &&
                        touched.lastName &&
                        errors.lastName
                      }
                      fullWidth
                      required
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      type='email'
                      size='small'
                      margin='none'
                      value={values.email || ''}
                      label='Email'
                      name='email'
                      onChange={handleChange}
                      onBlur={(e) => {
                        handleBlur(e);
                      }}
                      error={Boolean(errors.email && touched.email)}
                      helperText={
                        Boolean(errors.email) && touched.email && errors.email
                      }
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <PhoneNumberTextField
                      className='bob'
                      size='small'
                      // margin='none'
                      value={values.phoneNumber || ''}
                      label='Phone'
                      name='phoneNumber'
                      onChange={handleChange}
                      onBlur={(e) => {
                        handleBlur(e);
                      }}
                      error={Boolean(errors.phoneNumber && touched.phoneNumber)}
                      helperText={
                        Boolean(errors.phoneNumber) &&
                        touched.phoneNumber &&
                        errors.phoneNumber
                      }
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid container justify='flex-end'>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name='isActive'
                        color='primary'
                        onClick={() =>
                          setFieldValue('isActive', !values.isActive)
                        }
                        size='small'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.isActive || true}
                        checked={values.isActive}
                      />
                    }
                    label='Active'
                  />
                </Grid>
                <Grid container justify='flex-end'>
                  <FormBtns
                    isSubmitting={isSubmitting}
                    onClose={onClose}
                    saveText='Save'
                  />
                </Grid>
              </CardContent>
            </Card>
          </form>
        );
      }}
    </Formik>
  );
};

export default UserForm;
